import { gql } from '@apollo/client'

export const COMMENT_LIST_QUERY = gql`
  query CommentList($contentId: Int!, $limit: Int, $offset: Int) {
    commentList(
      content: [{ contentId: $contentId, published: true }]
      depthType: ROOT
      limit: $limit
      offset: $offset
      order: [["createdAt", "DESC"]]
    ) {
      comments {
        id
        uid
        pid
        contentId
        subject
        comment
        status
        createdAt
        userInfoPublic {
          uid
          avatar {
            small
            card
          }
        }
        commentsChildren(limit: 100, order: [["createdAt", "ASC"]]) {
          id
          uid
          pid
          subject
          comment
          status
          createdAt
          userInfoPublic {
            uid
            avatar {
              small
              card
            }
          }
        }
      }
      count
    }
  }
`

export const COMMENT_CREATE_MUTATION = gql`
  mutation CommentCreate($input: CommentCreateInput!) {
    commentCreate(input: $input) {
      success
      comment {
        id
        uid
        pid
        contentId
        subject
        comment
        status
        createdAt
        userInfoPublic {
          uid
          avatar {
            small
            card
          }
        }
      }
    }
  }
`

export const COMMENT_UPDATE_MUTATION = gql`
  mutation CommentUpdate($input: CommentUpdateInput!) {
    commentUpdate(input: $input) {
      success
      comment {
        id
        uid
        subject
        comment
        status
        createdAt
      }
    }
  }
`

export const COMMENT_REPORT_MUTATION = gql`
  mutation CommentReport($id: ID!) {
    commentReport(id: $id) {
      success
    }
  }
`
